<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import { onMount } from "svelte";
	import type { HTMLDialogAttributes } from "svelte/elements";
	import { on } from "svelte/events";
	import close from "@core/assets/icons/close.svg?raw";
	import { lockScroll } from "../../state/lockScroll.svelte.js";
	import Formatted from "./Formatted.svelte";

	let {
		show = $bindable(false),
		/* eslint-disable prefer-const */
		noBackdrop,
		...rest
		/* eslint-enable prefer-const */
	}: HTMLDialogAttributes & { show: boolean; noBackdrop?: boolean } = $props();

	let dialog = $state<HTMLDialogElement | null>(null);

	$effect(() => {
		if (!dialog) {
			return;
		}

		if (show && !dialog.open) {
			if (noBackdrop) {
				dialog.show();
			} else {
				dialog.showModal();
			}
		}
		if (!show && dialog.open) {
			dialog.close();
		}
	});

	$effect(() => {
		if (show && !lockScroll.lock) {
			lockScroll.lock = true;
		}
	});
	$effect(() => {
		if (!show) {
			lockScroll.lock = false;
		}
	});

	function closeOnBackdrop(event: MouseEvent): void {
		if (!event.target) {
			return;
		}

		if (!(event.target instanceof Node)) {
			return;
		}

		if (event.target.nodeName === "DIALOG") {
			show = false;
		}
	}

	// Not using on:click because svelte complains about accessibility (non-interactable elements with a mouse/keyboard event listener).
	onMount(() => dialog && on(dialog, "click", closeOnBackdrop));
</script>

{#if show && noBackdrop}
	<button
		aria-label="Zavřít modální okno"
		type="button"
		onclick={(): void => {
			show = false;
		}}
		class="modal-backdrop fixed inset-0 size-full z-[8887] cursor-default"
	></button>
{/if}
<dialog
	bind:this={dialog}
	{...rest}
	class={[
		"cmc-modal bg-transparent p-4 lg:min-w-96 max-w-full mx-auto open:flex",
		noBackdrop && "fixed z-[8888] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
		rest.class,
	]}
	onclose={(event: Event & { currentTarget: EventTarget & HTMLDialogElement }): void => {
		show = false;
		rest.onclose?.(event);
	}}
>
	<!-- This div element makes closing on backdrop work correctly -->
	<div class="bg-white/75 w-full backdrop-blur-[8px] relative p-4 rounded-3xl flex flex-col">
		<div class="z-10 flex justify-end p-1">
			<button
				onclick={(): void => {
					show = false;
				}}
				class="group/underline"
			>
				<div class="flex gap-4 text-cmcsecondary items-center">
					<span class="font-bold tracking-[0.05em] uppercase">
						<Formatted text="hover[[Zavřít]]" />
					</span>
					<Icon icon={close} class="size-8" />
				</div>
			</button>
		</div>

		<div class="pt-4 flex flex-col">
			{@render rest.children?.()}
		</div>
	</div>
</dialog>
